import {useState} from 'react'

import PropTypes from 'prop-types'

import {BASE_CLASS, FORM_ID} from '../config.js'
import SearchAiField from './SearchAiField.js'

/**
 * Search AI Quick Filters modal content (for small devices)
 * Use BasicModal on parent with this Content and combined Footer to avoid nested modals
 */
const SearchAiQuickFiltersModalContent = ({
  isLoading,
  onSearch = () => {},
  onShowResults = () => {},
  onCloseModal = () => {}
}) => {
  const [currentInputSearch, setCurrentInputSearch] = useState('')

  const handleChangeInputSearch = search => {
    setCurrentInputSearch(search)
  }

  const handleInputSearch = async e => {
    e?.preventDefault()
    const cleanedInputSearch = currentInputSearch.trim()

    if (cleanedInputSearch) {
      await onSearch({query: cleanedInputSearch})

      // Close modal once the search is performed
      onCloseModal()
      setCurrentInputSearch('')
      onShowResults?.()
    }
  }

  return (
    <form id={FORM_ID} className={`${BASE_CLASS}-modal`} onSubmit={handleInputSearch}>
      <SearchAiField
        value={currentInputSearch}
        onChange={handleChangeInputSearch}
        onSubmit={handleInputSearch}
        isLoading={isLoading}
      />
    </form>
  )
}

SearchAiQuickFiltersModalContent.displayName = 'SearchAiQuickFiltersModalContent'
SearchAiQuickFiltersModalContent.propTypes = {
  isLoading: PropTypes.bool,
  onSearch: PropTypes.func,
  onShowResults: PropTypes.func,
  onCloseModal: PropTypes.func
}

export default SearchAiQuickFiltersModalContent
